/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, July 2022
 * @format
 * @flow
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import PopupHeader from '../PopupHeader';
import strings from '../../globalization';
import classes from './EmailReceipt.module.css';

const EmailReceipt = ({
  onClose,
  onSubmit,
  defaultEmailAddress,
}) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setEmail(defaultEmailAddress);
  }, []);

  const onPressDone = () => {
    let isValid = false;
    isValid = validateEmail(email);
    if (isValid) {
      onSubmit(email);
    } else {
      setError(strings.PopupContentWrapper_email_error);
    }
  };

  const validateEmail = email => {
    // eslint-disable-next-line max-len
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  return (
    <div className={classes.container}>
      <PopupHeader onClose={onClose} />
      <div className={classes.wrapper}>
        <span className={classes.label}>Please enter your email address</span>
        <input
          type={'email'}
          placeholder="Email Address"
          value={email}
          onChange={e => setEmail(e.target.value)}
          className={classes.input}
        />
        <span className={classes.errorTxt}>{error}</span>
        <Button
          className={classes.button}
          onClick={onPressDone}
        >
          <span className={classes.text}>DONE</span>
        </Button>
      </div>
    </div>
  )
}

export default EmailReceipt;

EmailReceipt.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  defaultEmailAddress: PropTypes.string,
};

EmailReceipt.defaultProps = {
  onClose: () => { },
  onSubmit: () => { },
  defaultEmailAddress: '',
};
